import React from "react";
import {Input, Paper} from "@material-ui/core";
import './SearchBarDesktop.css';
import SearchIcon from '../../../resources/wrappers/SearchIcon'
import {ISearchBarState} from "../ISearchBarState";

export class SearchBarDesktop extends React.Component<any, ISearchBarState> {
    inputRef = undefined;

    constructor(props: any) {
        super(props);
        this.state = {
            inputValue: "",
            inputFocused: false
        }
        this.handleSearchTextInserted = this.handleSearchTextInserted.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
    }

    private handleSearchTextInserted(event: any){
        this.setState({inputValue: event.target.value});
        this.props.onValueChanged(event.target.value);
    }

    private handleDelete(){
        this.setState({inputValue: ""});
        this.setState({inputFocused: false});
        this.props.onValueChanged("");
    }

    render() {
        return <Paper id={"search-bar-root"}>
            <div className={"search-bar-input-container"}>
                <Input
                    disableUnderline={true}
                    id={"search-bar-input"}
                    placeholder={this.props.placeholder}
                    fullWidth
                    ref={this.inputRef}
                    value={this.state.inputValue}
                    onChange={this.handleSearchTextInserted}
                    autoFocus={true}
                    onFocus={() => {
                        this.setState({inputFocused: true});
                        if(this.props.onFocus !== undefined){
                            this.props.onFocus();
                        }
                    }}
                    onBlur={() => {
                        this.setState({inputFocused: false});
                        if(this.props.onBlur !== undefined){
                            this.props.onBlur();
                        }
                    }}
                />
            </div>
            <div className={"search-bar-icon-container"}>
                <SearchIcon width={"32px"} height={"32px"} focused={this.state.inputFocused} />
            </div>
        </Paper>;
    }
}